var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.365723 1.89966C0.365723 1.23706 0.920449 0.699219 1.60427 0.699219H15.8855C16.5696 0.699219 17.124 1.23706 17.124 1.89966V16.2573C17.124 16.9201 16.5696 17.4575 15.8855 17.4575H1.60427C0.920514 17.4575 0.365723 16.9201 0.365723 16.2575V1.89947V1.89966Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45827 14.7238V7.17918H2.95055V14.7238H5.45853H5.45827ZM4.20493 6.14926C5.07924 6.14926 5.62356 5.56992 5.62356 4.84591C5.6072 4.10541 5.07924 3.54224 4.22156 3.54224C3.36329 3.54224 2.80273 4.10541 2.80273 4.84585C2.80273 5.56986 3.34686 6.1492 4.1885 6.1492H4.20474L4.20493 6.14926ZM6.84633 14.7238H9.35385V10.511C9.35385 10.2858 9.37022 10.06 9.43647 9.8992C9.61767 9.44849 10.0303 8.98194 10.7232 8.98194C11.6304 8.98194 11.9935 9.67374 11.9935 10.6881V14.7238H14.5009V10.398C14.5009 8.08066 13.264 7.0023 11.6141 7.0023C10.2615 7.0023 9.66742 7.75832 9.33736 8.27325H9.35405V7.17944H6.84646C6.87919 7.88722 6.84626 14.7241 6.84626 14.7241L6.84633 14.7238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSmall);
export default __webpack_public_path__ + "static/media/linkedin-small.5f8f368046948f5781f633b6ffdbc982.svg";
export { ForwardRef as ReactComponent };